const styles = {
  container: {
    maxWidth: 1400,
    mx: 'auto',
  },
  tableContainer: {
    mt: 24,
  },
  uploadSection: {
    p: { xs: 24, md: 40 },
    textAlign: 'center',
    border: '2px dashed',
    borderColor: 'grey.300',
    backgroundColor: 'grey.50',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'action.hover',
    },
  },
  dragOver: {
    borderColor: 'primary.main',
    backgroundColor: 'primary.light',
    borderWidth: 3,
    transform: 'scale(1.02)',
  },
  uploadButton: {
    mt: 16,
    px: 32,
    py: 12,
  },
  dataSection: {
    mt: 24,
  },
  infoSection: {
    p: 24,
    textAlign: 'center',
  },
  formSection: {
    p: 24,
    mb: 24,
  },
};

export default styles;
